import Vue from 'vue'
import Embed from 'v-video-embed'

// global register
Vue.use(Embed)
